<template lang="pug">
ValidationProvider(
  v-slot="{ errors }"
  :rules="rules"
  :name="name"
  :disabled="!required"
)
  .form-group.text(:class="{ 'has-error': errors[0] }")
    .row(v-show="!(required || textAreaShown)")
      .col-xs-12
        label.control-label-btn(@click="showTextArea")
          i.hi.hi-16(:class="icon")
          a
            | {{ addNoteLabel }}
    .row(v-show="required || textAreaShown")
      .col-xs-12(v-if="required")
        label.control-label {{ noteLabel }}
      .col-xs-4(v-else)
        label.control-label {{ noteLabel }}

      .col-xs-8(v-if="!required")
        .control-label-btn.pull-right
          a(@click.stop="hideTextArea")
            | {{ removeNoteLabel }}
    textarea.form-control(
      v-show="required || textAreaShown"
      ref="textarea"
      :name="name"
      :value="value"
      :placeholder="placeholder"
      :rows="rows"
      @input="onInput"
    )
    span.help-block {{ errors[0] }}
</template>

<script>
export default {
  name: 'TimeEntriesTextarea',
  props: {
    name: { type: String },
    value: { type: String },
    placeholder: { type: String },
    label: { type: String },
    required: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'default',
    },
    icon: {
      type: String,
      default: 'hi-edit',
    },
    rows: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      textAreaShown: false,
    };
  },
  computed: {
    rules() {
      return this.required ? 'required' : '';
    },
    removeNoteLabel() {
      return `Remove ${this.label.toLowerCase()}`;
    },
    addNoteLabel() {
      return `Add ${this.label.toLowerCase()}`;
    },
    noteLabel() {
      let inputLabel = this.label;

      if (this.required) {
        inputLabel += '*';
      }

      return inputLabel;
    },
  },
  methods: {
    onInput(event) {
      const value = event.target.value;

      this.$emit('input', value);
    },
    showTextArea() {
      this.textAreaShown = true;
      this.$nextTick(() => this.$refs.textarea.focus());
    },
    hideTextArea() {
      this.$emit('input', '');
      this.textAreaShown = false;
    },
  },
};
</script>
